import axios from "axios";

function them(hopDong) {
  return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/personal/hopdong/them", hopDong);
};
function getAll() {
  return axios.get(process.env.REACT_APP_URL_SERVER + "/cus/personal/hopdong/getall");
};
function timHopDongTheoMa(maHD) {
  return axios.get(process.env.REACT_APP_URL_SERVER + "/cus/personal/hopdong/getbymahd?maHD="+maHD);
};
function capNhat(hopDong) {
  return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/personal/hopdong/capnhat", hopDong);
};
function xoa(ids) {
  return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/personal/hopdong/xoa", ids);
};
function xuLyHetHan(hopDong) {
  
  return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/personal/hopdong/xulyhethan", hopDong);
};
function importFile(file){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/hopdong/import",file);
};
function saveImportFile(listKH){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/personal/hopdong/savelist",listKH);
};
const HopDongPersonalService = {
  them,
  getAll,
  capNhat,
  timHopDongTheoMa,
  xoa,
  xuLyHetHan,
  importFile,
  saveImportFile
};
export default HopDongPersonalService;
